import React, { useEffect, useRef, useState } from 'react';
import diagnosisIcon from '@/imgs/diagnosis-icon.png';
import configIcon from '@/imgs/config-icon.png';
import insightsIcon from '@/imgs/insights-icon.png';
import { useFunctionButtons } from '../hooks';
import { getRedPointStatusApi } from '@/api/copilot';
import useUserStore from '@/stores/userStore';

const FunctionButtons: React.FC = () => {
  const { handleDiagnosis, handleCustomAssetAllocation, handleRiskAssessment } =
    useFunctionButtons();

  const [redPointNum, setRedPointNum] = useState<number>(0);

  const { taskId } = useUserStore();
  const hasFetched = useRef(false);

  const getRedPointStatus = async () => {
    // [8, 9, 10, 11].forEach(async value => {
    //   const res = await getRedPointStatusApi({
    //     uuid: followUserId,
    //     value
    //   });
    //   console.log(res, 'res');
    // });
    try {
      const res = await getRedPointStatusApi({
        uuid: taskId
      });
      setRedPointNum(Number(res || 0));
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (taskId && !hasFetched.current) {
      getRedPointStatus();
      hasFetched.current = true;
    }
  }, [taskId]);

  return (
    <div className="rounded-lg border border-gray-100 bg-white px-3 py-4 custom:px-12">
      <div className="flex items-center justify-between gap-2">
        {/* 持仓深度诊断 */}
        <div className="flex cursor-pointer flex-col items-center gap-1" onClick={handleDiagnosis}>
          <div className="h-6 w-6">
            <img src={diagnosisIcon} alt="诊断" className="h-full w-full object-contain" />
          </div>
          <span className="text-sm text-gray-800">持仓深度诊断</span>
        </div>

        {/* 定制资产配置 */}
        <div
          className="flex cursor-pointer flex-col items-center gap-1"
          onClick={handleCustomAssetAllocation}
        >
          <div className="h-6 w-6">
            <img src={configIcon} alt="配置" className="h-full w-full object-contain" />
          </div>
          <span className="text-sm text-gray-800">定制资产配置</span>
        </div>

        {/* AI投顾洞察 */}
        <div
          className="flex cursor-pointer flex-col items-center gap-1"
          onClick={handleRiskAssessment}
        >
          <div className="relative">
            <div className="h-6 w-6">
              <img src={insightsIcon} alt="洞察" className="h-full w-full object-contain" />
            </div>
            {redPointNum > 0 && (
              <div
                className={`absolute top-[-5px] rounded-full bg-red-500 px-1 text-xs text-white ${
                  redPointNum < 10
                    ? 'right-[-5px]'
                    : redPointNum > 9
                    ? 'right-[-10px]'
                    : redPointNum > 99
                    ? 'right-[-16px]'
                    : 'right-[-25px]'
                }`}
              >
                {redPointNum}
              </div>
            )}
          </div>
          <span className="text-sm text-gray-800">AI投顾洞察</span>
        </div>
      </div>
    </div>
  );
};

export default FunctionButtons;
